import { LoaderFunctionArgs, useLoaderData, useOutletContext } from "react-router";
import { Helmet } from "@dr.pogodin/react-helmet";
import {
  ICONS_PREPEND,
  KEMONO_SITE,
  SITE_NAME,
  THUMBNAILS_PREPEND,
} from "#env/env-vars";
import { fetchFanboxProfileFancards } from "#api/profiles";
import { PageSkeleton } from "#components/pages";
import { IFanCard } from "#entities/files";
import { OutletContext } from "./creator-page";

interface IProps {
  cards: IFanCard[];
}

export function FancardsPage() {
  const { cards } = useLoaderData() as IProps;
  const { creator } = useOutletContext() as OutletContext;
  const title = "Fancards";
  const heading = "Fancards";

  return (
    <PageSkeleton name="use" title={title} heading={heading}>
      <Helmet>
        <meta name="id" content={creator.id} />
        <meta name="service" content={creator.service} />
        <meta name="artist_name" content={creator.name} />
        {/* <link rel="canonical" href="{{ g.canonical_url }}" /> */}

        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta
          property="og:image"
          content={`${ICONS_PREPEND ?? KEMONO_SITE}/icons/${creator.service}/${
            creator.id
          }`}
        />
        {/* <meta property="og:url" content="{{ g.canonical_url }}" /> */}
      </Helmet>

      <div className="paginator" id="paginator-top">
        <div id="fancard-container">
          {cards.length === 0 ? (
            <div className="no-results">
              <h2 className="site-section__subheading">
                Nobody here but us chickens!
              </h2>
              <p className="subtitle">There are no uploads for your query.</p>
            </div>
          ) : (
            cards.map((card) => (
              <article key={card.id} className="fancard__file">
                <span title={card.added.slice(0, 7)}>
                  Added {card.added.slice(0, 7)}
                </span>
                <a
                  className="fileThumb"
                  href={`${card.server ?? ""}${card.path}`}
                >
                  <img
                    src={`${THUMBNAILS_PREPEND}/thumbnail/${card.path}`}
                    loading="lazy"
                    data-src={`${THUMBNAILS_PREPEND}/thumbnail/${card.path}`}
                  />
                </a>
              </article>
            ))
          )}
        </div>
      </div>
    </PageSkeleton>
  );
}

export async function loader({ params }: LoaderFunctionArgs): Promise<IProps> {
  const service = params.service!.trim();
  const creatorId = params.creatorId!.trim();

  if (service != "fanbox") {
    throw new Response("Not Found", { status: 404 });
  }

  const cards = fetchFanboxProfileFancards(creatorId);

  return {
    cards: await cards,
  };
}
